import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../layout/Others/Response_Processing";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";

function MobileDeepLinkingSettings(props) {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({
    namespace: "android_app",
    package_name: "",
    sha256_cert_fingerprints: "",
    ios_bundle_id: "",
    ios_team_id: "",
    android_url: "",
    ios_url: "",
    android_app_store_id: "",
    ios_app_store_id: "",
    user_id: "",
  });
  const [errors, setErrors] = useState({});
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(() => {
    const getSettings = async () => {
      try {
        const reqData = await fetch(
          `${process.env.REACT_APP_Baseurl}/admin/deep_linking_setting/index`,
          { headers: headers }
        );

        const resData = await reqData?.json();
        if (resData?.status && resData?.Deep_Linking_Setting) {
          setSettings(resData.Deep_Linking_Setting);
        }
      } catch (error) {
        console.error("Error fetching mobile deep linking settings:", error);
      }
    };
    getSettings();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/deep_linking_setting/store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(settings),
        }
      );

      const resjson = await res.json();

      if (resjson.status === true) {
        props.setApiresponsealert(resjson);
        props.setShowalert(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        props.setApiresponsealert(resjson);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Mobile Deep Linking Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={"Android App Links Configuration"} />
            <MessageLabel text={"Namespace (e.g., android_app)"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter Namespace"} 
              id="namespace" 
              name="namespace" 
              onChange={handleInput} 
              value={settings?.namespace} 
            />
            <MessageLabel text={"Package Name"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter Android Package Name"} 
              id="package_name" 
              name="package_name" 
              onChange={handleInput} 
              value={settings?.package_name} 
            />
             <MessageLabel text={"Android App Scheme (e.g., myscheme://)"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter Android App Scheme"} 
              id="android_url" 
              name="android_url" 
              onChange={handleInput} 
              value={settings?.android_url} 
            />
             <MessageLabel text={"Play Store URL"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter Play Store URL"} 
              id="android_app_store_id" 
              name="android_app_store_id" 
              onChange={handleInput} 
              value={settings?.android_app_store_id} 
            />
          </Wrapper>
          
          <Wrapper className="mt-4">
            <MessageHeading text={"Security Verification"} />
            <MessageLabel text={"SHA256 Fingerprints (comma separated)"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter SHA256 Fingerprints"} 
              id="sha256_cert_fingerprints" 
              name="sha256_cert_fingerprints" 
              onChange={handleInput} 
              value={settings?.sha256_cert_fingerprints} 
            />
            <p className="mt-2 text-muted small">
              Note: Verification files (<code>assetlinks.json</code> and <code>apple-app-site-association</code>) are now served dynamically from the backend settings.
            </p>
          </Wrapper>
        </LeftWrapper>
        
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"iOS Universal Links Configuration"} />
            <MessageLabel text={"iOS Team ID"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter iOS Team ID"} 
              id="ios_team_id" 
              name="ios_team_id" 
              onChange={handleInput} 
              value={settings?.ios_team_id} 
            />
             <MessageLabel text={"iOS Bundle ID"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter iOS Bundle ID"} 
              id="ios_bundle_id" 
              name="ios_bundle_id" 
              onChange={handleInput} 
              value={settings?.ios_bundle_id} 
            />
            <MessageLabel text={"iOS App Scheme (e.g., myscheme://)"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter iOS App Scheme"} 
              id="ios_url" 
              name="ios_url" 
              onChange={handleInput} 
              value={settings?.ios_url} 
            />
            <MessageLabel text={"App Store URL"} />
            <AdminCustomInput 
              type="text" 
              placeHolder={"Enter App Store URL"} 
              id="ios_app_store_id" 
              name="ios_app_store_id" 
              onChange={handleInput} 
              value={settings?.ios_app_store_id} 
            />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default MobileDeepLinkingSettings;
